import Flex from "../../components/Flex"
import Screen from "./components/Screen"

import "./Career.scss"
import { spacing } from "./styles"
import { Spec } from "../../components/Icons"
import datasource from "../../datasource"

const {
    title,
    subTitle,
    jobboxTitle,
    joboxSubTitle,
    jobs
} = datasource.careers


export default () => {

    return (
        <div className="career">
            <Screen className="career__title-box">
                <Flex vertical align="center" gap={spacing("4xl")}>
                    <div className="career__title">{title}</div>
                    <div className="career__subTitle">{subTitle}</div>
                </Flex>
            </Screen>
            <Screen className="job-box-screen">
                <div className="job-box">
                    <Flex gap={219}>
                        <Flex vertical gap={10}>
                            <div className="job-box__title">{jobboxTitle}</div>
                            <div className="job-box__subTitle">{joboxSubTitle}</div>
                        </Flex>
                        <Flex vertical gap={spacing("6xl")}>
                            <Flex gap={spacing("2xl")}>
                                <Job idx={0}></Job>
                                <Job idx={1}></Job>
                            </Flex>
                            <Flex gap={spacing("2xl")}>
                                <Job idx={2}></Job>
                            </Flex>
                        </Flex>
                    </Flex>
                </div>
            </Screen>
        </div>
    )
}


const Job = (props: {idx: number}) => {

    const {
        idx
    } = props

    return (
        <Flex vertical className="job" gap={spacing("2xl")}>
            <div className="job__title">{jobs[idx]['title']}</div>
            <Flex vertical className="job__content" gap={30}>
                <div className="job__content__icon">
                    <Spec idx={idx} width={37} height={34}></Spec>
                </div>
                <div className="job__content__description">
                    {jobs[idx]['description']}
                </div>
            </Flex>
        </Flex>
    )
}